import Button from '../../../sf-components/Button/Button';
import Label from '../../../sf-components/Label/Label';
import TextInput from '../../../sf-components/TextInput/TextInput';
import ButtonStyles from '../../../sf-components/Button/ButtonStyles';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import AlertsOptionsToggles from '../../containers/AlertsManagement/components/AlertsOptionsToggles';
import EventSettingsDrawer from '../../containers/AlertsManagement/components/EventSettingsDrawer';
import { SYSLOG_CUSTOMIZABLE_EVENTS, SYSLOG_EVENTS_SETTINGS } from './SyslogConsts';
import { SECURITY_EVENTS_TYPES, SYSLOG_PROTOCOLS, SYSLOG_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import List from '../../../sf-components/List/List';
import ListItem from '../../../sf-components/List/ListItem';
import { httpPost } from '../../../utils';
import NotificationsEventDrawer from '../Email/NotificationsEventDrawer';
import { Icon, Icons, MenuButton } from '@silverfort/sf-components';
import { SUBCATEGORIES } from '../../common/categories';

const { SYSLOG_SERVER } = SUBCATEGORIES;

const SyslogServerDetails = ({ data, otherSyslogServers, onSave, onCancel, isEdit = false }) => {
    const [syslogData, setSyslogData] = useState(data);
    const [eventSelections, setEventSelections] = useState();
    const [eventInEdit, setEventInEdit] = useState();
    const [nameError, setNameError] = useState();
    const [ipError, setIpError] = useState();
    const [portError, setPortError] = useState();
    const [showCancelModal, setShowCancelModal] = useState(false);

    const validateName = (name) => {
        if (!name) return 'Mandatory field';
        if (otherSyslogServers.find((syslog) => syslog.name === name && syslog.id !== syslogData.id)) {
            return 'Name already exists';
        }
    };

    const validateIp = (ip) => {
        if (!ip) return 'Mandatory field';
    };

    const validatePort = (port) => {
        if (!port) return 'Mandatory field';
        if (isNaN(port)) return 'Port must contain number values only';
    };

    const protocolList = (
        <List>
            <ListItem
                selected={syslogData.protocol === SYSLOG_PROTOCOLS.TCP.value}
                label={SYSLOG_PROTOCOLS.TCP.label}
                value={SYSLOG_PROTOCOLS.TCP.value}
                onClick={() => setSyslogData({ ...syslogData, protocol: SYSLOG_PROTOCOLS.TCP.value })}
            />
            <ListItem
                selected={syslogData.protocol === SYSLOG_PROTOCOLS.UDP.value}
                label={SYSLOG_PROTOCOLS.UDP.label}
                value={SYSLOG_PROTOCOLS.UDP.value}
                onClick={() => setSyslogData({ ...syslogData, protocol: SYSLOG_PROTOCOLS.UDP.value })}
            />
        </List>
    );

    const systemToggles = {
        AUDIT: SYSLOG_TYPES.AUDIT,
        SETTINGS: SYSLOG_TYPES.SETTINGS,
        INTEGRATIONS: SYSLOG_TYPES.INTEGRATIONS,
        NOTIFICATIONS: SYSLOG_TYPES.NOTIFICATIONS
    };

    const authenticationsToggles = {
        AUTHENTICATIONS: SYSLOG_TYPES.AUTHENTICATIONS
    };

    const sendProdData = (data) => {
        httpPost('/settings/sendSyslogServerProductData', { data, isEdit });
    };

    const eventsDrawerDescription = (
        <div className="w-[512px] text-wrap">
            To know which events and notification you would like to assign to this syslog notification please visit our{' '}
            <a
                href="https://docs.silverfort.com/docs/admin-console-notifications-and-events"
                target="_blank"
                className="text-sf-primary"
                rel="noreferrer">
                documentation
            </a>
            . Use the events ID to add them
        </div>
    );

    const isNotificationEvent = eventInEdit === SYSLOG_TYPES.NOTIFICATIONS.id;

    return (
        <div className="font-sf flex flex-col p-6 w-full h-166 border border-sf-gray-100 bg-white rounded-lg">
            <div className="mb-4 flex items-center bg-sf-gray-50 pl-6 h-20 border border-sf-gray-100 rounded-lg">
                <Icon className="text-sf-gray-400" icon={Icons.Cube} size={36} />
                <div className="ml-2 text-sm">
                    <div className="font-medium text-sf-gray-800">{SYSLOG_SERVER.NAME}</div>
                    <div className="font-normal text-sf-gray-500">
                        For more information about this integration and the required prerequisites, see
                        <a
                            className="ml-1 text-sf-primary-500"
                            href="https://docs.silverfort.com/docs/syslog-integrations"
                            target="_blank"
                            rel="noopener noreferrer">
                            here
                        </a>
                        .
                    </div>
                </div>
            </div>
            <div className="flex p-2">
                <div className="w-1/5 h-10 flex items-center">
                    <Label text={'Server name'} mandatory={true} />
                </div>
                <div className="w-4/5 h-10 mb-1">
                    <TextInput
                        ValidationMessage={nameError}
                        placeholder={'Add server name'}
                        value={syslogData.name}
                        onChange={(val) => {
                            setNameError();
                            setSyslogData({ ...syslogData, name: val });
                        }}
                        className={'w-72'}
                    />
                </div>
            </div>
            <div className="flex p-2">
                <div className="w-1/5 h-10 flex items-center">
                    <Label text={'Host'} mandatory={true} />
                </div>
                <div className="w-4/5 h-10 mb-1 flex">
                    <div>
                        <TextInput
                            ValidationMessage={ipError}
                            placeholder={'IP address or host name'}
                            value={syslogData.target}
                            onChange={(val) => {
                                setIpError();
                                setSyslogData({ ...syslogData, target: val });
                            }}
                            className={'w-72'}
                        />
                    </div>
                    <span className="flex items-center">
                        <Icon size={24} icon={Icons.Separate} />
                    </span>
                    <div>
                        <TextInput
                            ValidationMessage={portError}
                            placeholder={'Port'}
                            value={syslogData.port}
                            onChange={(val) => {
                                setSyslogData({ ...syslogData, port: val });
                            }}
                            className={'w-[80px]'}
                        />
                    </div>
                </div>
            </div>
            <div className="flex p-2">
                <div className="w-1/5 h-10 flex items-center">
                    <Label text={'Protocol'} mandatory={true} />
                </div>
                <div className="w-4/5 h-10 mb-1">
                    <div className="bg-sf-gray-50 w-50 h-10 flex items-center pl-3 pr-1 rounded-lg text-13 justify-between">
                        <span>{SYSLOG_PROTOCOLS[syslogData.protocol.toUpperCase()].label}</span>
                        <MenuButton
                            iconClassName={`bg-transparent w-4 h-4 text-sf-gray-500`}
                            icon={Icons.ChevronDown}
                            content={protocolList}
                            className="right-[-4px] top-[36px] p-[0] w-[200px] z-50"
                        />
                    </div>
                </div>
            </div>
            <div className="flex p-2 mt-2">
                <div className="w-1/5 h-10 flex items-center">
                    <Label text={'Events'} />
                </div>
                <div className="flex w-4/5 flex-col mt-0.5">
                    <AlertsOptionsToggles
                        data={syslogData}
                        setData={setSyslogData}
                        eventInEdit={eventInEdit}
                        setEventInEdit={setEventInEdit}
                        customizedEvents={SYSLOG_CUSTOMIZABLE_EVENTS}
                        eventsTypes={systemToggles}
                        title={'Platform Events'}
                    />
                    <AlertsOptionsToggles
                        alertType="Syslog"
                        data={syslogData}
                        setData={setSyslogData}
                        eventInEdit={eventInEdit}
                        setEventInEdit={setEventInEdit}
                        customizedEvents={SYSLOG_CUSTOMIZABLE_EVENTS}
                        eventsTypes={{ ...SECURITY_EVENTS_TYPES, DAILY_INSIGHTS: SYSLOG_TYPES.DAILY_INSIGHTS }}
                        title={'Security Events'}
                    />
                    <AlertsOptionsToggles
                        data={syslogData}
                        setData={setSyslogData}
                        eventInEdit={eventInEdit}
                        setEventInEdit={setEventInEdit}
                        customizedEvents={SYSLOG_CUSTOMIZABLE_EVENTS}
                        eventsTypes={authenticationsToggles}
                        title={'Authentications'}
                    />
                </div>
            </div>

            <div className="flex justify-end items-center h-8">
                <Button
                    text={'Cancel'}
                    buttonStyle={ButtonStyles.TertiarySolid}
                    onClick={() => (data !== syslogData ? setShowCancelModal(true) : onCancel())}
                    className="mr-1"
                />
                <Button
                    text={'Save'}
                    disabled={data === syslogData}
                    onClick={() => {
                        const nameValidation = validateName(syslogData.name);
                        const ipValidation = validateIp(syslogData.target);
                        const portValidation = validatePort(syslogData.port);
                        if (nameValidation || ipValidation || portValidation) {
                            setNameError(nameValidation);
                            setIpError(ipValidation);
                            setPortError(portValidation);
                        } else {
                            setNameError();
                            setIpError();
                            setPortError();
                            const sysLogDataToSave = {
                                ...syslogData,
                                lastModified: Date.now()
                            };
                            onSave(sysLogDataToSave);
                            sendProdData(sysLogDataToSave);
                        }
                    }}
                />
            </div>

            <EventSettingsDrawer
                alertType={'syslog'}
                data={syslogData}
                eventInEdit={!isNotificationEvent && eventInEdit}
                eventSelections={eventSelections}
                eventSettings={SYSLOG_EVENTS_SETTINGS[eventInEdit]}
                setEventSelections={setEventSelections}
                setEventInEdit={setEventInEdit}
                setData={setSyslogData}
            />
            <NotificationsEventDrawer
                data={syslogData.settings[SYSLOG_TYPES.NOTIFICATIONS.id]}
                open={isNotificationEvent}
                setOpen={setEventInEdit}
                onSave={(updatedData) =>
                    setSyslogData({
                        ...syslogData,
                        settings: { ...syslogData.settings, [SYSLOG_TYPES.NOTIFICATIONS.id]: updatedData }
                    })
                }
                title={SYSLOG_TYPES.NOTIFICATIONS.label}
                description={eventsDrawerDescription}
            />
            {showCancelModal && (
                <Modal
                    className="font-sf flex flex-col justify-center"
                    id={'cancelModal'}
                    dialogClassName="w-[360px] [&_.modal-content]:rounded-lg [&_.modal-content]:shadow-modal-light"
                    show
                    onHide={() => setShowCancelModal(false)}
                    keyboard={false}
                    backdrop="static">
                    <Modal.Header className="border-hidden pt-4 pr-6 pb-0 pl-0" closeButton>
                        <div className="px-4 pb-4 mb-1 text-14 font-medium text-sf-gray-800">
                            Continue without changes?
                        </div>
                    </Modal.Header>
                    <Modal.Body className=" text-13 px-4 pb-6 h-full border-t border-b">
                        Any changes will be lost, are you sure you want to proceed?
                    </Modal.Body>
                    <Modal.Footer className="border-hidden px-6">
                        <div className="flex justify-end items-center">
                            <Button
                                onClick={() => setShowCancelModal(false)}
                                text={'Cancel'}
                                buttonStyle={ButtonStyles.TertiarySolid}
                                className="mr-2"
                            />
                            <Button onClick={onCancel} text={'Discard Changes'} />
                        </div>
                    </Modal.Footer>
                </Modal>
            )}
        </div>
    );
};

export default SyslogServerDetails;
